module.exports = __webpack_public_path__ + "img/img3.1e489055.png";